import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import InputField from "../../atoms/InputField";
import Button from "../../atoms/Button";
import { LOGIN } from "../../../api/apiAuth";

const LoginForm = () => {
    const navigate = useNavigate ();

    const validate = (values) => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!values.email) { errors.email = "El email es requerido"; } 
            else if (!emailRegex.test(values.email)) { errors.email = "El email no es válido"; }
        if (!values.password) { errors.password = "La contraseña es requerida"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
                const normalizedEmail = values.email.trim().toLowerCase();
                const data = await LOGIN(normalizedEmail, values.password);
                if (data?.token) {
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("user", JSON.stringify(data.user));
                    toast.success("Sesión iniciada correctamente");
                    navigate("/dashboard");
                } else { 
                    toast.error("Credenciales invalidas");
                }
        } catch (error) {
            toast.error("Error al iniciar sesión");
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    return(
        <div>
            <Formik initialValues={{ email: "", password: "" }} onSubmit={handleSubmit} validate={validate}>
				{({ isSubmitting }) => (
                    <Form className="w-full flex flex-col items-center justify-center text-center space-y-4 bg-gray-400/50 p-8 rounded-md">
						<InputField name="email" type="text" label=" Correo electrónico"placeholder="Nombre de usuario" />
						<InputField name="password" label="Contraseña" type="password" placeholder="Contraseña" />
                    <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Iniciar sesión"} type="submit" bgColor="blue" disabled={isSubmitting}/>
                </Form>
                )}
            </Formik>
        </div>
    )
};

export default LoginForm;